var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("User Dashboard")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }